import { z } from 'zod'

/**
 * The social sign-in providers, with no UI imports: server-only code (the
 * env settings, and through them the worker bundle) reads these without
 * pulling in components and their assets. `connections.tsx` re-exports them.
 */
export const GOOGLE_PROVIDER_NAME = 'google'
export const APPLE_PROVIDER_NAME = 'apple'
export const FACEBOOK_PROVIDER_NAME = 'facebook'
// to add another provider, set their name here and add it to the providerNames below

export const providerNames = [
	GOOGLE_PROVIDER_NAME,
	APPLE_PROVIDER_NAME,
	FACEBOOK_PROVIDER_NAME,
] as const
export const ProviderNameSchema = z.enum(providerNames)
export type ProviderName = z.infer<typeof ProviderNameSchema>
